import React from "react";
import { GlitterSparkles } from "./GlitterSparkles";
type AboutUsPageProps = {
  onBack: () => void;
  onShopAll: () => void;
};
const email = "pickenspassion@gmail.com";
const phoneHref = "tel:+12088813989";
const phoneDisplay = "(208) 881-3989";
const mobileBackground = "https://cdn.magicpatterns.com/uploads/6kgUVZBJt4Na2xSQAHtezM/ChatGPT_Image_Oct_5,_2026,_09_22_29_PM.png";
const desktopBackground = "https://cdn.magicpatterns.com/uploads/swatQzGpfmeNNzAo7K6iRj/ChatGPT_Image_Oct_5,_2026,_09_25_27_PM.png";
const linkClass = "text-[#35dceb] underline decoration-transparent underline-offset-2 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]";

/** Text sits on a dark card so the jeweled background doesn't overpower it. */
const cardClass = "rounded-2xl border border-[#ff3aa2]/35 bg-[#10070f]/85 p-5 backdrop-blur-sm md:p-8";
function Section({
  heading,
  children
}: {
  heading: string;
  children: React.ReactNode;
}) {
  return <section aria-label={heading} className={`space-y-4 ${cardClass}`} data-id="element-57" data-mp="9k8dxfu4b8w1">
      <h2 className="text-2xl font-semibold tracking-tight text-[#35dceb] sm:text-3xl" data-id="element-58" data-mp="dnwjxu33pwf6">{heading}</h2>
      <div className="space-y-4 text-base leading-7 text-white/85" data-id="element-59" data-mp="ilewdugbutrx">{children}</div>
    </section>;
}
export function AboutUsPage({
  onBack,
  onShopAll
}: AboutUsPageProps) {
  return <main className="relative min-h-[100dvh] w-full bg-[#10070f] px-4 py-10 text-white sm:px-8 sm:py-14" data-id="element-60" data-mp="sc14l3lpsi0l">
      {/* Mobile: jeweled background pinned to the screen */}
      <div className="pointer-events-none fixed inset-0 bg-cover bg-center md:hidden" style={{
      backgroundImage: `url(${mobileBackground})`
    }} aria-hidden="true" data-id="element-61" data-mp="11cza5qbswxla" />
      {/* Desktop: wide jeweled background pinned to the screen */}
      <div className="pointer-events-none fixed inset-0 hidden bg-cover bg-center md:block" style={{
      backgroundImage: `url(${desktopBackground})`
    }} aria-hidden="true" data-id="element-62" data-mp="33659mwb3xz8z" />
      {/* Animated glitter over the background */}
      <div className="pointer-events-none fixed inset-0" aria-hidden="true" data-id="element-63" data-mp="fbazuai03eos">
        <GlitterSparkles count={500} data-id="element-64" data-mp="abon026340gi" />
      </div>

      <div className="relative mx-auto max-w-3xl" data-id="element-65" data-mp="o9n0l5ckzsuy">
        <button type="button" onClick={onBack} className="mb-6 rounded-full bg-[#10070f]/80 px-3 py-1.5 text-sm font-medium text-[#35dceb] underline decoration-transparent underline-offset-4 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#35dceb]" data-id="element-66" data-mp="obg3c9k2psxo">
          Back to home
        </button>

        <header className={cardClass} data-id="element-67" data-mp="12z1aqfnzeebe">
          <h1 className="text-4xl font-semibold tracking-tight text-[#ff5bad] sm:text-5xl" data-id="element-68" data-mp="1302nqpok5avr">About Pickens Passion</h1>
          <p className="mt-4 text-xl leading-8 text-white sm:text-2xl" style={{
          fontFamily: "'Kaushan Script', cursive"
        }} data-id="element-69" data-mp="1gytuts505wae">
            If it can be rhinestoned, we&apos;re probably going to try it.
          </p>
        </header>

        <div className={`mt-6 space-y-4 text-base leading-7 text-white/85 ${cardClass}`} data-id="element-70" data-mp="20kc5hfr2jods">
          <p data-id="element-71" data-mp="20hzq9acp3s4f">
            First came the rhinestone ducks and tumblers. Then came the question that keeps Pickens Passion growing: &ldquo;What else can we put rhinestones on?&rdquo;
          </p>
          <p className="font-semibold text-white" data-id="element-72" data-mp="1qnzguwads0pw">Turns out, quite a lot.</p>
          <p data-id="element-73" data-mp="1ctgm970oi1i5">
            Pens, tools, buckets—our collection keeps growing because we love giving everyday things a bold, sparkling personality. Some pieces are practical, some are unexpected, and every one brings a little more bling into the day.
          </p>
        </div>

        <div className="mt-6 space-y-6" data-id="element-74" data-mp="17wgdgocg2knc">
          <Section heading="Everyday things. Extra personality." data-id="element-75" data-mp="17tc133otsill">
            <p data-id="element-76" data-mp="twfexfjnjpb1">
              We believe the things you use can be just as fun as the things you wear. Your favorite pen doesn&apos;t have to be plain. Your tumbler can stand out. And yes, even your tools and buckets deserve their moment to shine.
            </p>
            <p data-id="element-77" data-mp="luo9y9simwk8">
              Our pieces are for people who love sparkle, appreciate bold details, and like a little personality in their everyday essentials. Whether you&apos;re choosing something for yourself or finding a gift for someone who loves all things bling, we want you to find a piece that makes you smile.
            </p>
          </Section>

          <Section heading="The passion behind the sparkle" data-id="element-78" data-mp="81q7y4lki67p">
            <p data-id="element-79" data-mp="33om5bwrbssj">
              The best part of Pickens Passion is seeing an idea become something you can hold, use, and show off. We&apos;re always looking for the next thing to transform, and we love hearing what catches your eye—or what you think we should rhinestone next.
            </p>
            <p data-id="element-80" data-mp="1silddal16q4e">
              Thank you for shopping with us, sharing our creations, and helping this small business grow. You give us even more reasons to keep creating.
            </p>
          </Section>

          <p className={`text-center text-2xl leading-9 text-[#ff5bad] sm:text-3xl ${cardClass}`} style={{
          fontFamily: "'Kaushan Script', cursive"
        }} data-id="element-81" data-mp="1w0iroirw9bdv">
            From ducks to daily essentials, we bring the bling.
          </p>

          <Section heading="Get in touch" data-id="element-82" data-mp="29sp9e9ap3qff">
            <p data-id="element-83" data-mp="29sgwwiihin4r">Have a question about a piece or an idea for something you&apos;d love to see sparkle? We&apos;d love to hear from you.</p>
            <address className="not-italic leading-7" data-id="element-84" data-mp="1d52ewgx6mi4m">
              <span className="block font-semibold text-white" data-id="element-85" data-mp="1h52wgafkv9fw">Pickens Passion</span>
              <span className="block" data-id="element-86" data-mp="1m2cswa1dwld8">Idaho Falls, ID 83404</span>
              <span className="block" data-id="element-87" data-mp="1r2h8lxugxc2e">
                <a href={`mailto:${email}`} className={linkClass} data-id="element-88" data-mp="1r3aaakeklbdo">
                  {email}
                </a>
              </span>
              <span className="block" data-id="element-89" data-mp="2xknm8xpsltuo">
                <a href={phoneHref} className={linkClass} data-id="element-90" data-mp="32h4loo2fzun2">
                  {phoneDisplay}
                </a>{" "}
                — call or text
              </span>
            </address>
            <button type="button" onClick={onShopAll} className="mt-2 inline-flex items-center justify-center rounded-full bg-[#ff3aa2] px-6 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-[#ff5bad] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-91" data-mp="27unwbfu0e3r2">
              Shop the collection
            </button>
          </Section>
        </div>
      </div>
    </main>;
}